export default __webpack_public_path__ + "static/media/icon-dot-gov.71cdb86ba74bf726a614e68c2cf7979a.svg";